
/** This is auto generated by scripts/pre-deploy.js */

export const version: string = "4.21.8";
